import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { states } from '@/lib/seo/states'

export const Route = createFileRoute('/online-poker/$state')({
  loader: ({ params }) => {
    const state = states.find((s) => s.slug === params.state)
    if (!state) throw notFound()
    return state
  },
  component: () => <Outlet />,
})
